import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// MUI
import Box from '@mui/material/Box';
import Container from "@mui/material/Container";

// Custom Components
import PublicPage from "@/ui/PublicPage/PublicPage";
import RegistrationForm from "@/views/Auth/RegistrationForm";

import model from "@/models/user";
import dataController from "@/lib/dataController";

import UserContext from "@/components/UserContext/UserContext";

function RegistrationPage() {

  const dc = new dataController(model)

  const userContext = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (userContext && userContext.id) {
      navigate(userContext.getDefaultUrl(userContext.organisationId));
    }
  }, [userContext, navigate]);

  return (
    <PublicPage>
      <Box m={2}>
        <Container maxWidth="sm">
          <RegistrationForm dc={dc} form="register_combined" mode="update" onClose={() => {}} />
        </Container>
      </Box>
    </PublicPage>
  )
}
export default RegistrationPage;
